import { render, staticRenderFns } from "./SubmitForm5.vue?vue&type=template&id=ae6d3288&scoped=true"
import script from "./SubmitForm5.vue?vue&type=script&lang=ts"
export * from "./SubmitForm5.vue?vue&type=script&lang=ts"
import style0 from "./SubmitForm5.vue?vue&type=style&index=0&id=ae6d3288&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6d3288",
  null
  
)

export default component.exports